module.exports = ["tensorflow","cryptocurr","decentr","qubit","misinform","gdpr","blockchain","ai","algorithm","5g","gradient","robot","iot","health","learn_algorithm","reinforc_learn","machin_learn","deep_neural","massiv_mimo","renew_energi","digit_currenc","distribut_ledger","smart_contract","mix_realiti","soft_robot","edg_comput","fake_news","hate_speech","person_data","black_box","social_media","wireless_sensor","open_data","neural_network"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/words_arxiv.json
// module id = RlWM
// module chunks = 1